import * as globalTypes from "Store/global/constants";

export const sendWelcomeEmail = (body: WelcomeEmailData) => ({
  type: globalTypes.SEND_WELCOME_EMAIL,
  body
});
export const sendWorkbook = (body: WorkbookEmailData) => ({
  type: globalTypes.SEND_WORKBOOK_EMAIL,
  body
});

export const resetAllMessages = () => ({
  type: globalTypes.RESET_ALL_MESSAGES
});

export const handleFetchAllTestTemplates = (): globalTypes.IHandleFetchAllTestsTemplates => ({
  type: globalTypes.HANDLE_FETCH_ALL_TESTS_TEMPLATES
});

export const setTestsTemplates = (payload: TestTemplate[]): globalTypes.ISetTestsTemplates => ({
  type: globalTypes.SET_TESTS_TEMPLATES,
  payload
});

export const handleFetchLessonsTemplates = (): globalTypes.IHandleFetchLessonsTemplates => ({
  type: globalTypes.HANDLE_FETCH_LESSONS_TEMPLATES
});

export const setLessonsTemplates = (
  payload: LessonTemplate[]
): globalTypes.ISetLessonsTemplates => ({
  type: globalTypes.SET_LESSONS_TEMPLATES,
  payload
});

export const handleFetchWorksheetsTemplates = (): globalTypes.IHandleFetchWorksheetsTemplates => ({
  type: globalTypes.HANDLE_FETCH_WORKSHEETS_TEMPLATES
});

export const setWorksheetsTemplates = (
  payload: WorksheetTemplate[]
): globalTypes.ISetWorksheetsTemplates => ({
  type: globalTypes.SET_WORKSHEETS_TEMPLATES,
  payload
});

/* Pagination types:
  * tests,
  * lessons,
  * worksheets,
  * templates,

  * studentLessons,
  * studentWorksheets,
  * studentTests
  *
  * classroomLessons
  * classroomWorksheets
  * classroomTests
* */
export const setPagination = (
  payload: Partial<Pagination>,
  paginationType: PaginationType,
  reset: boolean = false
): globalTypes.ISetPagination => ({
  type: globalTypes.SET_PAGINATION,
  payload,
  paginationType,
  reset
});

export const resetPagination = (paginationType: PaginationType): globalTypes.IResetPagination => ({
  type: globalTypes.RESET_PAGINATION,
  paginationType
});

export const setGlobalTemplateLoader = (
  payload: boolean
): globalTypes.ISetGlobalTemplateLoader => ({
  type: globalTypes.SET_GLOBAL_TEMPLATE_LOADER,
  payload
});

export const handleFetchWorksheetsFilterItems =
  (): globalTypes.IHandleFetchWorksheetsFilterItems => ({
    type: globalTypes.HANDLE_FETCH_WORKSHEETS_FILTER_ITEMS
  });

export const setWorksheetsFilterItems = (
  payload: FilterOption[]
): globalTypes.ISetWorksheetsFilterItems => ({
  type: globalTypes.SET_WORKSHEETS_FILTER_ITEMS,
  payload
});

export const handleFetchLessonsFilterItems = (): globalTypes.IHandleFetchLessonsFilterItems => ({
  type: globalTypes.HANDLE_FETCH_LESSONS_FILTER_ITEMS
});

export const setLessonsFilterItems = (
  payload: FilterOption[]
): globalTypes.ISetLessonsFilterItems => ({
  type: globalTypes.SET_LESSONS_FILTER_ITEMS,
  payload
});

// export const setDetailsModalData = (payload): globalTypes.ISetDetailsModalData => ({
//   type: globalTypes.SET_DETAILS_MODAL_DATA,
//   payload
// });

export const setErrorSignal = (payload: boolean): globalTypes.ISetErrorSignal => ({
  type: globalTypes.SET_ERROR_SIGNAL,
  payload
});

export const handleFetchSubjects = (): globalTypes.IHandleFetchSubjects => ({
  type: globalTypes.HANDLE_FETCH_SUBJECTS
});

export const setSubjects = (payload: Subject[]): globalTypes.ISetSubjects => ({
  type: globalTypes.SET_SUBJECTS,
  payload
});

/* Spinners' actions */

export const setActionSpinner = (payload: boolean): globalTypes.ISetActionSpinner => ({
  type: globalTypes.SET_ACTION_SPINNER,
  payload
});

export const setGlobalSpinner = (payload: boolean): globalTypes.ISetGlobalSpinner => ({
  type: globalTypes.SET_GLOBAL_SPINNER,
  payload
});

export const setFetchSpinner = (payload: boolean): globalTypes.ISetFetchSpinner => ({
  type: globalTypes.SET_FETCH_SPINNER,
  payload
});

export const setFetchDetailsSpinner = (payload: boolean): globalTypes.ISetFetchDetailsSpinner => ({
  type: globalTypes.SET_FETCH_DETAILS_SPINNER,
  payload
});

export const setFetchCalendarSpinner = (
  payload: boolean
): globalTypes.ISetFetchCalendarSpinner => ({
  type: globalTypes.SET_FETCH_CALENDAR_SPINNER,
  payload
});

export const setFetchSublistSpinner = (payload: boolean): globalTypes.ISetFetchSublistSpinner => ({
  type: globalTypes.SET_FETCH_SUBLIST_SPINNER,
  payload
});

/* End of spinners for whole application */

/**
 * @params: payload: template_lesson_id
 * **/
export const handleFetchLessonTemplateDetails = (
  payload: string
): globalTypes.IHandleFetchLessonTemplateDetails => ({
  type: globalTypes.HANDLE_FETCH_LESSON_TEMPLATE_DETAILS,
  payload
});

/**
 * @params: payload: template_worksheet_id
 * **/
export const handleFetchWorksheetTemplateDetails = (
  payload: string
): globalTypes.IHandleFetchWorksheetTemplateDetails => ({
  type: globalTypes.HANDLE_FETCH_WORKSHEET_TEMPLATE_DETAILS,
  payload
});

/**
 * @params: payload: template_test_id
 * **/
export const handleFetchTestTemplateDetails = (
  payload: string
): globalTypes.IHandleFetchTestTemplateDetails => ({
  type: globalTypes.HANDLE_FETCH_TEST_TEMPLATE_DETAILS,
  payload
});

export const handleFetchUnits = (): globalTypes.IHandleFetchUnits => ({
  type: globalTypes.HANDLE_FETCH_UNITS
});

/* HINTS LISTS */
export const handleFetchLessonsHints = (): globalTypes.IHandleFetchLessonsHints => ({
  type: globalTypes.HANDLE_FETCH_LESSONS_HINTS
});

export const setLessonsHints = (payload: Hint[]): globalTypes.ISetLessonsHints => ({
  type: globalTypes.SET_LESSONS_HINTS,
  payload
});

export const handleFetchWorksheetsHints = (): globalTypes.IHandleFetchWorksheetsHints => ({
  type: globalTypes.HANDLE_FETCH_WORKSHEETS_HINTS
});

export const setWorksheetsHints = (payload: Hint[]): globalTypes.ISetWorksheetsHints => ({
  type: globalTypes.SET_WORKSHEETS_HINTS,
  payload
});

export const setUnitFilterOptions = (
  payload: SelectOption[]
): globalTypes.ISetUnitFilterOptions => ({
  type: globalTypes.SET_UNIT_FILTER_OPTIONS,
  payload
});

export const handleFetchClassroomsSimplified = (
  all: boolean = false
): globalTypes.IHandleFetchClassroomsSimplified => ({
  type: globalTypes.HANDLE_FETCH_CLASSROOMS_SIMPLIFIED,
  all
});

export const setClassroomsSimplified = (
  payload: Partial<Classroom>[]
): globalTypes.ISetClassroomsSimplified => ({
  type: globalTypes.SET_CLASSROOMS_SIMPLIFIED,
  payload
});

export const handleFetchInstructorsSimplified = (
  all: boolean = false
): globalTypes.IHandleFetchInstructorsSimplified => ({
  type: globalTypes.HANDLE_FETCH_INSTRUCTORS_SIMPLIFIED,
  all
});

export const setInstructorsSimplified = (
  payload: Partial<Instructor>[]
): globalTypes.ISetInstructorsSimplified => ({
  type: globalTypes.SET_INSTRUCTORS_SIMPLIFIED,
  payload
});

export const handleFetchStudentsSimplified = (
  all: boolean = false
): globalTypes.IHandleFetchStudentsSimplified => ({
  type: globalTypes.HANDLE_FETCH_STUDENTS_SIMPLIFIED,
  all
});

export const setStudentsSimplified = (
  payload: Partial<Student>[]
): globalTypes.ISetStudentsSimplified => ({
  type: globalTypes.SET_STUDENTS_SIMPLIFIED,
  payload
});

export const handleFetchLocationsSimplified = (
  all: boolean = false
): globalTypes.IHandleFetchLocationsSimplified => ({
  type: globalTypes.HANDLE_FETCH_LOCATIONS_SIMPLIFIED,
  all
});

export const setLocationsSimplified = (
  payload: Partial<TLocation>[]
): globalTypes.ISetLocationsSimplified => ({
  type: globalTypes.SET_LOCATIONS_SIMPLIFIED,
  payload
});

export const handleFetchCourses = (): globalTypes.IHandleFetchCourses => ({
  type: globalTypes.HANDLE_FETCH_COURSES
});

// setCourses
export const setCourses = (payload: Course[]): globalTypes.ISetCourses => ({
  type: globalTypes.SET_COURSES,
  payload
});

// setActiveCourse
export const setActiveCourse = (payload: Course): globalTypes.ISetActiveCourse => ({
  type: globalTypes.SET_ACTIVE_COURSE,
  payload
});

export const setLessonTemplatePreview = (
  payload: LessonTemplate
): globalTypes.ISetLessonTemplatePreview => ({
  type: globalTypes.SET_LESSON_TEMPLATE_PREVIEW,
  payload
});

export const setWorksheetTemplatePreview = (
  payload: WorksheetTemplate
): globalTypes.ISetWorksheetTemplatePreview => ({
  type: globalTypes.SET_WORKSHEET_TEMPLATE_PREVIEW,
  payload
});

export const setCategoryTree = (payload: WorksheetCategory[]): globalTypes.ISetCategoryTree => ({
  type: globalTypes.SET_CATEGORY_TREE,
  payload
});

export const setWorksheetsByCategory = (
  payload: WorksheetTemplate[]
): globalTypes.ISetWorksheetsByCategories => ({
  type: globalTypes.SET_WORKSHEETS_BY_CATEGORY,
  payload
});

export const setReportSpinner = (payload: boolean): globalTypes.ISetReportSpinner => ({
  type: globalTypes.SET_REPORT_SPINNER,
  payload
});
